
import { useSearchParams, useNavigate } from "react-router-dom";
import { useProfile } from "@/hooks/useProfile";
import { supabase } from "@/integrations/supabase/client";
import { Profile } from "@/hooks/profile/types";

export const useProfileTab = () => {
  const [searchParams] = useSearchParams();
  const { profile, updateProfile } = useProfile();
  const navigate = useNavigate();
  
  const showPasswordChange = searchParams.get("action") === "change_password";

  const handleLogout = async () => {
    try {
      await supabase.auth.signOut();
      navigate("/auth");
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  const handleProfileUpdate = async (updates: Partial<Profile>) => {
    await updateProfile(updates);
  };

  return {
    profile,
    showPasswordChange,
    handleLogout,
    handleProfileUpdate,
    navigate
  };
};
